import {Component, forwardRef, Input, OnInit, Optional} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {GnFormItem} from '../json-form/json-form-item/FormItem';
import {GnFormItemComponent} from '../form/form-item/form-item.component';

@Component({
  selector: 'gn-hidden',
  template: ``,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => GnHiddenComponent),
    multi: true
  }]
})
@GnFormItem('hidden')
export class GnHiddenComponent implements ControlValueAccessor, OnInit {

  private innerValue: string;

  constructor(@Optional() private formItem: GnFormItemComponent) {
  }

  @Input() set value(v: string) {
    if (this.innerValue !== v) {
      this.innerValue = v;
      this.valueChange(this.innerValue);
    }
  }

  get value(): string {
    return this.innerValue;
  }

  ngOnInit(): void {
    if (this.formItem) {
      this.formItem.display = false;
    }
  }

  valueChange = (value: string) => {
  }

  registerOnChange(fn: any): void {
    this.valueChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

}
